/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../../../lib/api";
import LocalModalSkeleton from "../../Skeletons/LocalModalSkeleton";
import Modal from 'react-bootstrap/Modal';
import { ICities, ILocalModal } from "./types";
import { useFilters } from "../../../providers/filters";
import { useAbortableRequest } from "../../../hooks/abortableController";

export const LocalModal = ({ modal, closeModal, defaultState = "PR", defaultCity = "Curitiba" }: ILocalModal) => {
  const [cities, setCities] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { createController } = useAbortableRequest();
  const { states } = useFilters();

  const [selectedState, setSelectedState] = useState<string>(searchParams.get("state") || defaultState);
  const [selectedCity, setSelectedCity] = useState<string>(searchParams.get("location") || defaultCity);

  const handleGetCities = async (state: string) => {
    const abortController = createController(`handleGetCities`);
    try {
      setLoading(true);
      const { data }: ICities = await api.get(`/SpecialistDoctor/cities/${state}`,{
        signal: abortController.signal
      });
      setCities(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    closeModal(false);
  };

  const handleClickCity = (city: string) => {
    if (searchParams.get("location") === city) {
      searchParams.delete("page"); // reset paginação
      setSearchParams(searchParams);
      setSelectedCity(city);
      return handleCloseModal();
    }

    searchParams.set("state", selectedState);
    searchParams.set("location", city);
    searchParams.delete("page");
    setSearchParams(searchParams);

    return handleCloseModal();
  };

  const handleClickState = (state: string) => {
    if (loading) return;

    if (searchParams.get("state") === state) {
      return;
    }

    setSelectedState(state);
  };

  // Carregar cidades quando selectedState mudar
  useEffect(() => {
    if (selectedState) {
      handleGetCities(selectedState);
    }
  }, [selectedState]);

  return (
    <Modal
      show={modal}
      onHide={() => closeModal}
      backdrop="static"
      keyboard={false}
      className="text-body"
      centered
      scrollable
    >
      <div className="modal-header">
        <h5 className="modal-title">
          <i className="las la-map-marker me-2"></i>
          Locais para consulta
        </h5>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={handleCloseModal}
        ></button>
      </div>

      <div className="modal-body bg-light rounded-bottom">
        <div className="row">
          {/* ESTADOS */}
          <div className="col col-auto">
            <h6 className="text-muted text-uppercase small">Estado:</h6>
            <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
              <ul className="list-group">
                {states.map((state, index) => (
                  <button
                    className={`list-group-item list-group-item-action ${selectedState === state ? "active" : ""}`}
                    key={index}
                    onClick={() => handleClickState(state)}
                  >
                    <div className="row justify-content-between g-0">
                      <div className="col">
                        <span className="text-default">{state}</span>
                      </div>
                      <div className="col col-auto">
                        <i className="las la-angle-right me-n2 opacity-50"></i>
                      </div>
                    </div>
                  </button>
                ))}
              </ul>
            </div>
          </div>

          {/* CIDADES */}
          <div className="col">
            <h6 className="text-muted text-uppercase small">Cidade:</h6>
            {loading ? (
              <LocalModalSkeleton />
            ) : (
              <>
                {cities.length > 0 ? (
                  <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <ul className="list-group">
                      {cities.map((city, index) => (
                        <button
                          className={`list-group-item list-group-item-action ${selectedCity.toLocaleLowerCase() === city.toLocaleLowerCase() ? "active" : ""}`}
                          key={index}
                          onClick={() => handleClickCity(city)}
                        >
                          <div className="row justify-content-between g-0">
                            <div className="col">
                              <span className="text-default">
                                {city.toLowerCase()}
                              </span>
                            </div>
                          </div>
                        </button>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <p className="opacity-50 text-center py-5">Nenhuma Cidade cadastrada para este Estado.</p>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};
